import loadable from "@loadable/component";
import React from "react";
import useStaticContext from "@hooks/useStaticContext";

import Footer from "@components/Main/Shared/Footer";
import SchemaOrg from "@components/Global/Custom/SchemaOrg";

import StateBanner from "./StateBanner";
import StateCities from "./StateCities";
import StateBreadcrumbs from "./StateBreadcrumbs";

import schema from "./@data/schema.org";
import HeaderHome from "@components/Main/Shared/HeaderHome";

const State = () => {
	const { state } = useStaticContext();
	return (
		<React.Fragment>
			<HeaderHome />
			<StateBanner state={state} />
			<StateBreadcrumbs state={state} />
			<StateCities state={state} />
			<SchemaOrg schema={schema(state)} />
			<Footer />
		</React.Fragment>
	);
};

export default State;

export const loader = (route) =>
	loadable(() => import("./State.component"), { ssr: !!route.ssr });
